const createNewProject = async(projectTitle, setProjects) =>{
    try{
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
        const response = await fetch(`${API_BASE_URL}/createProject`, {
            method:'POST',
            credentials: 'include',
            headers:{
                'Content-Type': 'application/json',
                "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body:JSON.stringify({projectTitle}),
        });
        const result = await response.json();
        // add the new project to the projects array
        setProjects((projects) => [...projects, result]);
    } catch(error){
        console.error('Error: ', error)
    }
}

export default createNewProject;